import { Col, Row } from 'react-bootstrap';
import CurrencyField from '../../../benefit/fields/CurrencyField';
import IncomeMeasurementSelector from '../../../benefit/common/IncomeMeasurementSelector';

const EditableOtherFundBenefit = ({
  state,
  pledgeAmount,
  onPledgeAmountChange,
  incomeMeasurementType,
  onIncomeMeasurementTypeChange,
  incomeMeasurementPercentage,
  onIncomeMeasurementPercentageChange,
  isSubmitting }) => {

  return (
    <>
      <Row className="mt-3">
        <Col>
          <IncomeMeasurementSelector
            state={state}
            incomeMeasurementType={incomeMeasurementType}
            onIncomeMeasurementTypeChange={onIncomeMeasurementTypeChange}
            incomeMeasurementPercentage={incomeMeasurementPercentage}
            onIncomeMeasurementPercentageChange={onIncomeMeasurementPercentageChange}
          />
        </Col>
      </Row>
      <hr />
      <Row>
        <Col md={6}>
          <h4>Benefit Amount</h4>
          <CurrencyField
            value={pledgeAmount}
            fieldName="Pledge Amount"
            onChange={onPledgeAmountChange}
            isSubmitting={isSubmitting}
            required
          />
        </Col>
      </Row>
    </>
  );
};

export default EditableOtherFundBenefit;